import React from 'react';

import { useCurrentUser } from '~/domains/auth/queries';
import {
  setBusinessIdToCookie,
  useStoreBusinessId,
} from '~/hooks/useBusinessId';
import { useProvideReferrer } from '~/hooks/useReferrer';
// import { hackleClient } from '~/libs/hackle';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

// NOTE: AppHooks에서는 suspense는 사용하지 말 것
// _app 전역에서 실행되는데, useCurrentUser를 동일하게 사용하고 있는 페이지가 있을 경우
// AppHooks에서 suspense가 걸리면 같이 걸릴 수 있기 때문에 AppHooks에서는 suspense를 걸지 않습니다.
const AppHooks = () => {
  const { user } = useCurrentUser();
  const { setBusinessId } = useBusinessIdStore();

  useStoreBusinessId();
  useProvideReferrer();

  // event-tracker user 정보 추가
  React.useEffect(() => {
    if (!user) {
      return;
    }

    const {
      // trackingId, uuid,
      businessPublicId,
    } = user;

    // hackleClient.setUser({
    //   id: trackingId,
    //   userId: uuid,
    // });

    // cookie에 businessId가 없는 경우에만,
    // api를 통해 받아온 현재 선택된 businessId 전역상태에 저장
    if (!document.cookie.includes('businessId')) {
      setBusinessId(businessPublicId.toString());
      setBusinessIdToCookie(businessPublicId.toString());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.updatedAt]);

  return null;
};

export default AppHooks;
